import Loader from '@components/Loader'
import { useConciergeId } from '@hooks/useConciergeId'
import { getDwEnv, getWisdomId } from '@lib/config'
import { Box } from '@mui/material'
import { useEffect, useState } from 'react'

export default function WebsitePreview() {
  const conciergeId = useConciergeId()
  const iframeScale = 0.8
  const [wisdomId, setWisdomId] = useState<string>()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!conciergeId) return
    let isMounted = true

    async function fetchWisdomId() {
      try {
        const id = await getWisdomId(conciergeId)
        if (isMounted) setWisdomId(id)
      } catch (error) {
        console.error('Failed to fetch wisdomId:', error)
      } finally {
        if (isMounted) setLoading(false)
      }
    }

    fetchWisdomId()
    return () => {
      isMounted = false
    }
  }, [conciergeId])

  if (loading) {
    return <Loader />
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        border: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
        width: { xs: '100%', sm: 500 },
        height: { xs: '100%', sm: '100%' },
        maxWidth: { xs: '100%', sm: '80vw' },
        maxHeight: { xs: '100%', sm: 750 },
        borderRadius: { xs: 0, sm: '15px' },
        margin: 'auto',
        boxShadow: 4,
      }}
    >
      {wisdomId ? (
        <iframe
          title='Website Preview'
          src={getPreviewUrl(wisdomId)}
          style={{
            width: `${100 / iframeScale}%`,
            height: `${100 / iframeScale}%`,
            flexGrow: 1,
            border: 'none',
            transform: `scale(${iframeScale})`,
            transformOrigin: 'top left',
          }}
        ></iframe>
      ) : (
        <Box color='error.main'>Failed to load preview, try refreshing.</Box>
      )}
    </Box>
  )
}

function getPreviewUrl(wisdomId: string) {
  const env = getDwEnv()
  return `https://${env}-concierge.webwisdom.ai/?wisdomId=${encodeURIComponent(wisdomId)}`
}
